<div class="overview-div" *ngIf="isOverview">
	<i class="fa fa-list-ul overview-icon" aria-hidden="true" (click)="toggleStats()"></i>
	<div class="r4-overview-stats-div" [ngClass]="{ 'r4-overview-stats-div-with-data': hasData }" *ngIf="showStats">
		<div class="map-overview-stats-widget" [ngClass]="{ 'map-overview-stats-widget-data': hasData }">
			<div class="overview-title">Quick Overview</div>
			<div class="quick-stats-scroll" *ngIf="hasData">
				<table class="rwd-table">
					<tr *ngFor="let overviewStat of overviewStats; let last = last">
						<div class="stat-title">
							<label
								for="styled-checkbox-{{ overviewStat.productId }}"
								[ngClass]="{ 'product-disabled': !overviewStat.productSelected }"
								>{{ overviewStat.productName === 'Connected TV' ? 'CTV/OTT' : overviewStat.productName }}</label
							>
						</div>
						<div *ngIf="overviewStat.productName !== 'Email'">
							<div [ngClass]="{ 'disabled-td': !overviewStat.productSelected }" class="stats-value-div">
								<div class="stats-value">{{ overviewStat.impressions | formatNumber : true }}</div>
								<div class="ovw-stat">IMPRESSIONS</div>
							</div>
							<div [ngClass]="{ 'disabled-td': !overviewStat.productSelected }" class="stats-value-div ml-10">
								<div
									class="stats-value"
									*ngIf="overviewStat.productName != 'Connected TV' && overviewStat.productName != 'Streaming Audio'"
								>
									{{ overviewStat.clicks | formatNumber : true }}
								</div>
								<div
									class="stats-value"
									*ngIf="overviewStat.productName === 'Connected TV' || overviewStat.productName == 'Streaming Audio'"
								>
									{{ overviewStat.completions | formatNumber : true }}
								</div>
								<div
									class="ovw-stat"
									*ngIf="overviewStat.productName != 'Connected TV' && overviewStat.productName != 'Streaming Audio'"
								>
									CLICKS
								</div>
								<div
									class="ovw-stat"
									*ngIf="overviewStat.productName === 'Connected TV' || overviewStat.productName == 'Streaming Audio'"
								>
									COMPLETIONS
								</div>
							</div>
							<div [ngClass]="{ 'disabled-td': !overviewStat.productSelected }" class="stats-value-div ml-10">
								<div
									class="stats-value"
									*ngIf="overviewStat.productName != 'Connected TV' && overviewStat.productName != 'Streaming Audio'"
								>
									<span *ngIf="overviewStat.ctr; else naBlock">{{ overviewStat.ctr | number : '1.2-2' }}%</span>
									<ng-template #naBlock>
										<span>n/a</span>
									</ng-template>
								</div>
								<div
									class="stats-value"
									*ngIf="overviewStat.productName == 'Connected TV' || overviewStat.productName == 'Streaming Audio'"
								>
									<span *ngIf="overviewStat.completions_rate; else naBlock"
										>{{ overviewStat.completions_rate | number : '1.2-2' }}%</span
									>
									<ng-template #naBlock>
										<span>n/a</span>
									</ng-template>
								</div>
								<div
									class="ovw-stat"
									*ngIf="overviewStat.productName != 'Connected TV' && overviewStat.productName != 'Streaming Audio'"
								>
									CTR
								</div>
								<div class="ovw-stat" *ngIf="overviewStat.productName === 'Connected TV'">VCR</div>
								<div class="ovw-stat" *ngIf="overviewStat.productName === 'Streaming Audio'">ACR</div>
							</div>
						</div>
						<div *ngIf="overviewStat.productName == 'Email'">
							<div [ngClass]="{ 'disabled-td': !overviewStat.productSelected }" class="stats-value-div">
								<div class="stats-value">{{ overviewStat.audience | formatNumber : true }}</div>
								<div class="ovw-stat">SENDS</div>
							</div>
							<div [ngClass]="{ 'disabled-td': !overviewStat.productSelected }" class="stats-value-div ml-10">
								<div class="stats-value">
									{{ overviewStat.opens | formatNumber : true }}
								</div>
								<div class="ovw-stat">OPENS</div>
							</div>
							<div [ngClass]="{ 'disabled-td': !overviewStat.productSelected }" class="stats-value-div ml-10">
								<div class="stats-value">
									<span *ngIf="overviewStat.clicks; else naBlock">{{ overviewStat.clicks | formatNumber : true }}</span>
									<ng-template #naBlock>
										<span>n/a</span>
									</ng-template>
								</div>
								<div class="ovw-stat">CLICKS</div>
							</div>
						</div>
					</tr>
				</table>
			</div>
			<div class="r4-map-no-data" *ngIf="!hasData">
				<div class="no-data-message">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
